export const CHART_GROUPED_BY_VALUES = {
  hourly: 'hourly',
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
};
